import React from 'react';
import ReactDOM from 'react-dom';

function Toast({ toast, onDismiss }) {
  const { id, badge, title, message } = toast;
  return (
    <div
      style={{
        background: '#1a1500',
        border: '1px solid #3d3000',
        borderTop: '3px solid #E79F23',
        borderRadius: '8px',
        padding: '12px 13px',
        width: '270px',
        boxShadow: '0 4px 24px rgba(0,0,0,0.7)',
        marginBottom: '10px',
        animation: 'toastSlideIn 0.3s ease',
      }}
    >

      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '7px', marginBottom: '7px' }}>
        {badge && (
          <span style={{
            background: '#E79F23', color: '#000',
            fontSize: '9px', fontWeight: 700,
            padding: '2px 6px', borderRadius: '10px',
            letterSpacing: '0.5px', flexShrink: 0,
          }}>
            {badge}
          </span>
        )}
        <span style={{ fontSize: '12px', fontWeight: 600, color: '#E79F23', flex: 1 }}>
          {title}
        </span>
        <button
          aria-label="dismiss"
          onClick={() => onDismiss(id)}
          style={{
            background: 'none', border: 'none', color: '#666',
            cursor: 'pointer', fontSize: '14px', lineHeight: 1, flexShrink: 0,
            padding: 0,
          }}
        >
          ×
        </button>
      </div>

      {/* Message */}
      <p style={{ fontSize: '11px', color: '#bbb', lineHeight: 1.45, margin: 0 }}>
        {message}
      </p>

      {/* Status footer — only when badge is present */}
      {badge && (
        <div style={{
          marginTop: '9px',
          paddingTop: '9px',
          borderTop: '1px solid #2a1f00',
          display: 'flex', alignItems: 'center', gap: '6px',
          fontSize: '10px', color: '#666',
        }}>
          <span style={{
            width: '6px', height: '6px',
            background: '#4caf50', borderRadius: '50%', flexShrink: 0,
            boxShadow: '0 0 4px #4caf50',
          }} />
          Generating files automatically…
        </div>
      )}
    </div>
  );
}

export function ToastContainer({ toasts, onDismiss }) {
  if (!toasts.length) return null;

  return ReactDOM.createPortal(
    <div style={{
      position: 'fixed',
      top: '20px',
      right: '20px',
      zIndex: 9999,
      pointerEvents: 'none',
    }}>
      <style>{`
        @keyframes toastSlideIn {
          from { opacity: 0; transform: translateX(30px); }
          to   { opacity: 1; transform: translateX(0); }
        }
      `}</style>
      {toasts.map(toast => (
        <div key={toast.id} style={{ pointerEvents: 'auto' }}>
          <Toast toast={toast} onDismiss={onDismiss} />
        </div>
      ))}
    </div>,
    document.body
  );
}
